export default {
  form: "form",
  success: "success"
};
